import { faHeart } from "@fortawesome/free-solid-svg-icons";
import React from "react";
import QInputProps from "./QInputProps";
import QRatingGeneric from "./QRatingGeneric";

export default function QRatingHeart(p: QInputProps) {
  return <QRatingGeneric icon={faHeart} color="#ff0000" {...p}/>
}